import { __decorate } from "tslib";
import { observer } from 'mobx-react';
import { TextField } from '../text-field/TextField';
import { $l } from '../locale-context';
import { FieldType } from '../data-set/enum';
let UrlField = class UrlField extends TextField {
    constructor() {
        super(...arguments);
        this.type = 'url';
    }
    get defaultValidationMessages() {
        const label = this.getProp('label');
        return {
            valueMissing: $l('UrlField', label ? 'value_missing' : 'value_missing_no_label', { label }),
            typeMismatch: $l('UrlField', 'type_mismatch'),
        };
    }
    getFieldType() {
        return FieldType.url;
    }
};
UrlField.displayName = 'UrlField';
UrlField = __decorate([
    observer
], UrlField);
export default UrlField;
